module.exports = __webpack_public_path__ + "img/colorful3-end.df77de88.png";